import React, { useRef, useState } from 'react';
import clsx from 'clsx';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { FileData } from '../../../../../hooks/api/articles';
import commonStyles from '../../index.module.scss';

import styles from './index.module.scss';

interface VideoWithThumbnailProps {
  thumbnail: FileData;
  video: FileData;
}

function VideoWithThumbnail({ thumbnail, video }: VideoWithThumbnailProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handlePlayClick = () => {
    setIsPlaying(true);
    // setTimeout(() => videoRef.current?.play(), 300);
  };

  if (!video) {
    return (
      <div className={commonStyles.imgContainer}>
        <img src={thumbnail.location} alt="thumbnail" />
      </div>
    );
  }

  return (
    <div className={styles.thumbnailContainer}>
      {!isPlaying ? (
        <div className={styles.thumbnailWrapper} onClick={handlePlayClick} role="button" tabIndex={0}>
          <img
            src={thumbnail.location}
            alt="thumbnail"
            className={styles.thumbnailImage}
          />
          <div className={styles.playButton}>
            <svg
              className=""
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      ) : (
        <>
          <video
            autoPlay
            ref={videoRef}
            controls
            controlsList="nodownload"
            src={video?.location}
            preload="metadata"
            className={clsx(styles.videoContent, {
              [styles.playingVid]: isPlaying,
            })}
            onClick={(e) => e.stopPropagation()}
          >
            <track kind="captions" />
          </video>
          <Button
            type="default"
            icon={<CloseOutlined />}
            onClick={() => setIsPlaying(false)}
            className={styles.closeButton}
          />
        </>
      )}
    </div>
  );
}

export default VideoWithThumbnail;
